import React, { useEffect, useRef, lazy, createElement } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface FluidWebModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export const FluidWebModal: React.FC<FluidWebModalProps> = ({
  isOpen,
  onClose
}) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  // Lock body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  // Load the fluid-navigate script and call loadIframe when iframe loads
  useEffect(() => {
    if (!isOpen) return;
    const existingScript = document.querySelector('script[src="https://app.fluid-form.ai/fluid-navigate.js"]');
    if (!existingScript) {
      const script = document.createElement('script');
      script.src = 'https://app.fluid-form.ai/fluid-navigate.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }, [isOpen]);
  const handleIframeLoad = () => {
    if (iframeRef.current && typeof (window as any).loadIframe === 'function') {
      ;
      (window as any).loadIframe(iframeRef.current);
    }
  };
  // Close on Escape key
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      window.addEventListener('keydown', handleKeyDown);
    }
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-129">
      {isOpen && <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 sm:p-10" data-id="element-130">
          {/* Backdrop */}
          <motion.div className="absolute inset-0 bg-black/50 backdrop-blur-sm" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} onClick={onClose} data-id="element-131" />

          {/* Modal */}
          <motion.div className="relative bg-white rounded-2xl shadow-2xl border border-gray-200 w-full max-w-xl overflow-hidden max-h-[90vh] flex flex-col" initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} data-id="element-132">
            {/* Header with Close Button */}
            <div className="flex justify-end p-2 sm:p-3 pb-0" data-id="element-133">
              <button onClick={onClose} className="w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors" aria-label="Close modal" data-id="element-134">
                <XIcon size={16} className="text-gray-500" data-id="element-135" />
              </button>
            </div>

            {/* Iframe Container */}
            <div className="relative w-full flex-1 px-2 sm:px-8 pb-2 sm:pb-4 overflow-y-auto" data-id="element-136">
              <iframe ref={iframeRef} id="fluidform-iframe-fluidweb-waitlist" onLoad={handleIframeLoad} src="https://app.fluid-form.ai/ff/org_39ojnmw3A3YsoOMUVZghwHqA808/fluidweb-waitlist?sig=org_39ojnmw3A3YsoOMUVZghwHqA808-fluidweb-waitlist-5bbc138121d1f4b7&mode=headless&chatPath=chat-router" width="100%" title="FluidWeb Waitlist" frameBorder="0" scrolling="yes" allowTransparency={true} loading="lazy" style={{
            border: 0,
            background: 'transparent',
            width: '100%',
            minHeight: '350px',
            height: '100%',
            display: 'block'
          }} data-id="element-137" />
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
};